import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=22b6e6f6"
import script from "./Applicants.vue?vue&type=script&lang=js"
export * from "./Applicants.vue?vue&type=script&lang=js"
import style0 from "./Applicants.vue?vue&type=style&index=0&id=22b6e6f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports